export default "__VITE_ASSET__CRbed9Q1__"